import React from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import arrowImg from "../../assets/images/budget/arrowGo.png";
import ModalVideo from "../../newComponents/ModuleVideos/ModalVideo";
import { 
  InfoCircleOutlined, 
  LoadingOutlined,
  BankOutlined,
  PieChartOutlined,
  DollarOutlined,
  AimOutlined,
  SafetyOutlined,
  CreditCardOutlined,
  StockOutlined,
  LineChartOutlined,
  IdcardOutlined,
  SyncOutlined,
  BarChartOutlined
} from "@ant-design/icons";
import { AssetsReport } from "../../newComponents/AssetsNew/AssetsDashboardComponents/AssetsReport";
import { LiabilityReport } from "../../newComponents/LiabilityNew/LiabilityDashboardComponents/LiabilityReport";
import { InsuranceReport as InsuranceReportV2 } from "../../newComponents/V2Insurance/InsuranceDashboardComponents/InsuranceReport";
import { IncomeReport } from "../../newComponents/IncomeNew/IncomeDashboardComponets/IncomeReport";
import "./reports.css";
const ClientInfo = () => {
  const history = useHistory();
  const reportRef = React.useRef(null);
  const liabilityReportRef = React.useRef(null);
  const insuranceReportRef = React.useRef(null);
  const [downloadLoading, setDownloadLoading] = React.useState(false);
  const [liabilityDownloadLoading, setLiabilityDownloadLoading] = React.useState(false);
  const [insuranceDownloadLoading, setInsuranceDownloadLoading] = React.useState(false);
  const incomeReportRef = React.useRef(null);
  const [incomeDownloadLoading, setIncomeDownloadLoading] = React.useState(false);

  const handleDownloadAssetReport = () => {
    if (reportRef.current && typeof reportRef.current.downloadPDF === "function") {
      reportRef.current.downloadPDF();
    }
  };

  const handleDownloadLiabilityReport = () => {
    if (liabilityReportRef.current && typeof liabilityReportRef.current.downloadPDF === "function") {
      liabilityReportRef.current.downloadPDF();
    }
  };

  const handleDownloadInsuranceReport = () => {
    if (insuranceReportRef.current && typeof insuranceReportRef.current.downloadPDF === "function") {
      insuranceReportRef.current.downloadPDF();
    }
  };

  const handleDownloadIncomeReport = () => {
    if (incomeReportRef.current && typeof incomeReportRef.current.downloadPDF === "function") {
      incomeReportRef.current.downloadPDF();
    }
  };

  const Reports = [
    // {
    //   id: 1,
    //   link: "/asset_item_report",
    //   title: "All Items Report",
    // },
    // {
    //   id: 2,
    //   link: "/report_prefessional_team",
    //   title: "Professional Team Report",
    // },
    // {
    //   id: 3,
    //   link: "/report_all_insurance_products",
    //   title: "All Insurance Products",
    // },
    {
      id: 4,
      link: "/report_asset",
      title: "Asset Report",
      icon: <BankOutlined />
    },
    {
      id: 5,
      link: "/reports/budget",
      title: "Budget Report",
      icon: <PieChartOutlined />
    },
    {
      id: 6,
      link: "/reports/budgetDetails",
      title: "Budget Detailed Report",
      disabled: true,
      icon: <BarChartOutlined />
    },
    {
      id: 9,
      link: "/income_report",
      title: "Income Report",
      disabled: false,
      icon: <DollarOutlined />
    },
    {
      id: 10,
      link: "/goals_report",
      title: "Goals Report",
      disabled: true,
      icon: <AimOutlined />
    },
    {
      id: 11,
      link: "/insurance_report",
      title: "Insurance Report",
      disabled: false,
      icon: <SafetyOutlined />
    },
    {
      id: 12,
      link: "/liabilities_credit_report",
      title: "Liabilities and Credit Report",
      disabled: false,
      icon: <CreditCardOutlined />
    },
    {
      id: 13,
      link: "/liquidity_report",
      title: "Liquidity Report",
      disabled: true,
      icon: <StockOutlined />
    },
    {
      id: 14,
      link: "/net_worth_report",
      title: "Net Worth Report",
      disabled: true,
      icon: <LineChartOutlined />
    },
    {
      id: 16,
      link: "/social_security_report",
      title: "Social Security Report",
      disabled: true,
      icon: <IdcardOutlined />
    },
    {
      id: 18,
      link: "/starting_a_business_report",
      title: "Subscription Report",
      disabled: true,
      icon: <SyncOutlined />
    },
  ];

  return (
    <React.Fragment>
      <div className="reportsMainSection">
        <ModalVideo module="Reports" autoOpen={true} />
        

        <div style={{
          background: 'linear-gradient(135deg, rgba(42, 61, 163, 0.05) 0%, rgba(255, 255, 255, 1) 100%)',
          border: '1px solid rgba(42, 61, 163, 0.1)',
          borderRadius: '20px',
          padding: '24px',
          marginBottom: '32px',
          display: 'flex',
          alignItems: 'center',
          gap: '20px',
          position: 'relative',
          overflow: 'hidden',
          boxShadow: '0 10px 25px -5px rgba(42, 61, 163, 0.05)'
        }}>
          <div style={{
            position: 'absolute',
            top: '-20px',
            right: '-20px',
            width: '120px',
            height: '120px',
            background: 'radial-gradient(circle, rgba(42, 61, 163, 0.03) 0%, transparent 70%)',
            borderRadius: '50%'
          }} />
          
          <div style={{
            background: '#2a3da3',
            color: 'white',
            minWidth: '52px',
            height: '52px',
            borderRadius: '16px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '24px',
            boxShadow: '0 8px 20px rgba(42, 61, 163, 0.2)',
            zIndex: 1
          }}>
            <InfoCircleOutlined />
          </div>

          <div style={{ zIndex: 1, flex: 1 }}>
            <h4 style={{
              margin: '0 0 6px 0',
              fontWeight: '700',
              fontSize: '18px',
              color: '#1a2a52',
              fontFamily: 'Poppins, sans-serif'
            }}>
              More Reports Coming Soon
            </h4>
            <div style={{
              fontSize: '15px',
              color: '#5e6a83',
              lineHeight: '1.6',
              fontFamily: 'Poppins, sans-serif'
            }}>
              We are currently crafting a comprehensive suite of financial reports.
              <div style={{ marginTop: '4px', fontSize: '14px', color: '#2a3da3', fontWeight: '500' }}>
                Is there a report you're missing? Tell us about it via the Feedback link on your sidebar.
              </div>
            </div>
          </div>
        </div>

        <h3 className="reportSelectHeading">Reports</h3>
        <div className="reportMain" >
          {Reports &&
            Reports.map((item, index) => {
              const isAssetReport = item.id === 4;
              const isLoadingThis = isAssetReport && downloadLoading;

              return (
                <div
                  key={index}
                    onClick={() => {
                    if (item.disabled) return;
                    if (isAssetReport) {
                      handleDownloadAssetReport();
                    } else if (item.id === 12) {
                      handleDownloadLiabilityReport();
                    } else if (item.id === 11) {
                      handleDownloadInsuranceReport();
                    } else if (item.id === 9) {
                      handleDownloadIncomeReport();
                    } else {
                      history.push(item.link);
                    }
                  }}
                  className={`reportMaincards ${item.disabled ? 'disabled-report' : ''} ${isLoadingThis || (item.id === 12 && liabilityDownloadLoading) || (item.id === 11 && insuranceDownloadLoading) || (item.id === 9 && incomeDownloadLoading) ? 'loading-report' : ''}`}
                  style={item.disabled ? { opacity: 0.5, cursor: 'not-allowed', pointerEvents: 'none' } : { cursor: 'pointer' }}
                >
                  <div className="reportMaincardsInner">
                    <div style={{ display: 'flex', alignItems: 'center', flex: 1, minWidth: 0 }}>
                      <div className="report-card-icon" style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        fontSize: '22px',
                        color: 'inherit',
                        backgroundColor: item.disabled ? 'rgba(0,0,0,0.04)' : 'rgba(255,255,255,0.15)',
                        width: '46px',
                        height: '46px',
                        borderRadius: '12px',
                        marginRight: '14px',
                        boxShadow: item.disabled ? 'none' : '0 4px 10px rgba(42, 61, 163, 0.08)',
                        transition: 'all 0.3s ease'
                      }}>
                        {item.icon || <InfoCircleOutlined />}
                      </div>

                      <div className="reportMainHeader" style={{ marginLeft: 0 }}>
                        <span className="reportSelectheadingValue">
                          {item.title}
                          {(isLoadingThis || (item.id === 12 && liabilityDownloadLoading) || (item.id === 11 && insuranceDownloadLoading) || (item.id === 9 && incomeDownloadLoading)) && (
                            <span style={{ 
                              marginLeft: '12px', 
                              fontSize: '13px', 
                              fontWeight: '500', 
                              opacity: 0.85,
                              fontStyle: 'italic'
                            }}>
                              Generating...
                            </span>
                          )}
                        </span>
                      </div>
                    </div>
                    <div>
                      {(isLoadingThis || (item.id === 12 && liabilityDownloadLoading) || (item.id === 11 && insuranceDownloadLoading) || (item.id === 9 && incomeDownloadLoading)) ? (
                        <LoadingOutlined style={{ fontSize: '18px', color: 'inherit' }} spin />
                      ) : (
                        <img src={arrowImg} height={"14px"} alt={item.name} />
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
        </div>
        
        {/* Hidden AssetsReport for PDF generation - using low opacity and z-index to ensure it renders for html2canvas while remaining invisible */}
        <div style={{ 
          position: 'fixed', 
          top: 0, 
          left: 0, 
          width: '1000px', // Fixed width to ensure consistent PDF layout
          height: '100%', 
          zIndex: -9999,
          opacity: 0.01,
          pointerEvents: 'none',
          overflow: 'hidden'
        }}>
          <AssetsReport 
            ref={reportRef} 
            onDownloadLoading={setDownloadLoading}
          />
        </div>

        {/* Hidden LiabilityReport for PDF generation */}
        <div style={{ 
          position: 'fixed', 
          top: 0, 
          left: 0, 
          width: '1000px',
          height: '100%', 
          zIndex: -9999,
          opacity: 0.01,
          pointerEvents: 'none',
          overflow: 'hidden'
        }}>
          <LiabilityReport 
            ref={liabilityReportRef} 
            onDownloadLoading={setLiabilityDownloadLoading}
          />
        </div>

        {/* Hidden InsuranceReport for PDF generation */}
        <div style={{ 
          position: 'fixed', 
          top: 0, 
          left: 0, 
          width: '1000px',
          height: '100%', 
          zIndex: -9999,
          opacity: 0.01,
          pointerEvents: 'none',
          overflow: 'hidden'
        }}>
          <InsuranceReportV2 
            ref={insuranceReportRef} 
            onDownloadLoading={setInsuranceDownloadLoading}
          />
        </div>

        {/* Hidden IncomeReport for PDF generation */}
        <div style={{ 
          position: 'fixed', 
          top: 0, 
          left: 0, 
          width: '1000px',
          height: '100%', 
          zIndex: -9999,
          opacity: 0.01,
          pointerEvents: 'none',
          overflow: 'hidden'
        }}>
          <IncomeReport 
            ref={incomeReportRef} 
            onDownloadLoading={setIncomeDownloadLoading}
          />
        </div>
      </div>
     
    </React.Fragment>
  );
};

export default connect()(ClientInfo);
